/**
 * BaB product card star ratings
 * Injects Junip-style stars under each bundle card title using
 * a Liquid-built variant/title → rating map (#custom-bab-ratings-data).
 */
(function () {
  var CARD_SELECTOR = '.bundle-product-card';
  var RATING_ATTR = 'data-custom-bab-rating';
  var DATA_ID = 'custom-bab-ratings-data';

  var updating = false;
  var scheduled = false;
  var ratingsMap = null;
  var config = {
    starColor: '#FDB600',
    showCount: false,
    enabled: true,
  };

  function loadConfig() {
    if (window.CustomBabRatingsConfig) {
      config.starColor = window.CustomBabRatingsConfig.starColor || config.starColor;
      config.showCount = !!window.CustomBabRatingsConfig.showCount;
      config.enabled = window.CustomBabRatingsConfig.enabled !== false;
    }

    var storeKey = document.querySelector('.junip-store-key');
    if (storeKey) {
      var color = storeKey.getAttribute('data-star-color');
      if (color) config.starColor = color;
      var showCount = storeKey.getAttribute('data-review-count-enabled');
      if (showCount === 'true') config.showCount = true;
      if (showCount === 'false') config.showCount = false;
      var enabled = storeKey.getAttribute('data-onsite-enabled');
      if (enabled === 'false') config.enabled = false;
    }
  }

  function loadRatingsMap() {
    if (ratingsMap) return ratingsMap;
    ratingsMap = {};
    var el = document.getElementById(DATA_ID);
    if (!el) return ratingsMap;
    try {
      ratingsMap = JSON.parse(el.textContent || '{}') || {};
    } catch (e) {
      ratingsMap = {};
    }
    return ratingsMap;
  }

  function normalizeTitle(text) {
    return String(text || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function getCardTitle(card) {
    var titleEl =
      card.querySelector('.awt-product-title') ||
      card.querySelector('.bundle-product-card__title');
    return titleEl ? titleEl.textContent : '';
  }

  function lookupRating(card) {
    var map = loadRatingsMap();
    var pid = card.getAttribute('data-pid');
    if (pid && map[pid]) return map[pid];

    var titleKey = 't:' + normalizeTitle(getCardTitle(card));
    if (map[titleKey]) return map[titleKey];

    return null;
  }

  function buildStarsHtml(rating, count) {
    var safeRating = Math.max(0, Math.min(5, Number(rating) || 0));
    var percent = (safeRating / 5) * 100;
    var label =
      safeRating.toFixed(1).replace(/\.0$/, '') +
      ' stars' +
      (count ? ', ' + count + ' reviews' : '');

    var starPathOutline =
      'm3.2 16.0001081c-.1687782 0-.33328968-.0531313-.47-.1521081-.24051968-.174488-.36451194-.4679107-.322-.762l.743-5.203-2.917-2.917c-.21191095-.21196521-.28756133-.52460199-.196-.81.09130759-.2851682.3345701-.49522345.63-.544l4.398-.734 2.218-4.435c.13744692-.27145241.41573373-.4426761.72-.443.3045618.00166772.58175678.1761261.715.45l2.123 4.362 4.498.801c.2933158.05211246.5333796.26289081.623.547.0898959.28455453.0135125.59548872-.198.806l-2.917 2.917.744 5.203c.042199.2957461-.0839008.5903645-.327.764-.2421349.1739598-.5609835.1986349-.827.064l-4.382-2.22-4.502 2.223c-.10996656.0547452-.23116004.0831081-.354.0831081zm1.51-2.8841081 3.357-1.658.892.452 2.327 1.178-.56-3.912.708-.707 1.29-1.29-3.234-.576-.446-.915-1.06-2.176-1.584 3.171-1.005.168-2.098.35 1.975 1.975-.141.99z';
    var starPathFilled =
      'm3.2 16.0001081c-.1687782 0-.33328968-.0531313-.47-.1521081-.24051968-.174488-.36451194-.4679107-.322-.762l.743-5.203-2.917-2.917c-.21191095-.21196521-.28756133-.52460199-.196-.81.09130759-.2851682.3345701-.49522345.63-.544l4.398-.734 2.218-4.435c.13744692-.27145241.41573373-.4426761.72-.443.3045618.00166772.58175678.1761261.715.45l2.123 4.362 4.498.801c.2933158.05211246.5333796.26289081.623.547.0898959.28455453.0135125.59548872-.198.806l-2.917 2.917.744 5.203c.042199.2957461-.0839008.5903645-.327.764-.2421349.1739598-.5609835.1986349-.827.064l-4.382-2.22-4.502 2.223c-.10996656.0547452-.23116004.0831081-.354.0831081z';

    function starSvg(path) {
      return (
        '<span class="custom-bab-card-rating__star" aria-hidden="true">' +
        '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="' +
        path +
        '" fill="currentColor"/>' +
        '</svg>' +
        '</span>'
      );
    }

    var outlines = '';
    var filled = '';
    for (var i = 0; i < 5; i++) {
      outlines += starSvg(starPathOutline);
      filled += starSvg(starPathFilled);
    }

    var countHtml =
      config.showCount && count
        ? '<span class="custom-bab-card-rating__count">(' + count + ')</span>'
        : '';

    return (
      '<div class="custom-bab-card-rating" ' +
      RATING_ATTR +
      ' aria-label="' +
      label +
      '" style="--custom-bab-star-color: ' +
      config.starColor +
      ';">' +
      '<span class="custom-bab-card-rating__stars">' +
      '<span class="custom-bab-card-rating__outline">' +
      outlines +
      '</span>' +
      '<span class="custom-bab-card-rating__fill" style="width: ' +
      percent +
      '%;">' +
      filled +
      '</span>' +
      '</span>' +
      countHtml +
      '</div>'
    );
  }

  function ensureRating(card) {
    if (!config.enabled) return;
    if (card.querySelector('[' + RATING_ATTR + ']')) return;

    var data = lookupRating(card);
    if (!data || !(Number(data.c) > 0) || !(Number(data.r) > 0)) return;

    var title =
      card.querySelector('.bundle-product-card__title') ||
      card.querySelector('.awt-product-title');
    if (!title) return;

    var insertAfter = title.closest('.bundle-product-card__title') || title;
    var wrapper = document.createElement('div');
    wrapper.innerHTML = buildStarsHtml(data.r, data.c);
    var ratingEl = wrapper.firstElementChild;
    if (!ratingEl) return;

    insertAfter.insertAdjacentElement('afterend', ratingEl);
  }

  function syncAll(root) {
    if (updating) return;
    updating = true;
    try {
      (root || document).querySelectorAll(CARD_SELECTOR).forEach(ensureRating);
    } finally {
      updating = false;
    }
  }

  function scheduleSync() {
    if (scheduled || updating) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      syncAll();
    });
  }

  function observe() {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        if (mutation.type !== 'childList') continue;

        for (var j = 0; j < mutation.addedNodes.length; j++) {
          var node = mutation.addedNodes[j];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches(CARD_SELECTOR)) {
            ensureRating(node);
          } else if (node.querySelectorAll) {
            node.querySelectorAll(CARD_SELECTOR).forEach(ensureRating);
          }
        }
      }
      scheduleSync();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  function init() {
    loadConfig();
    loadRatingsMap();
    syncAll();
    observe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
